module.exports = __webpack_public_path__ + "dd6827d0b8e52c25ede01f4c50c79f24.png";